import * as _ from 'lodash';
import * as moment from 'moment';

export function prepareBillingChartData(data) {
    let chartData = null,
        hasData = false,
        showMoney = true;

    const chartDateFormat = 'MMM D';
    const chartDateKeyFormat = 'MM-DD-YYYY';
    const now = Date.now();
    const dataByDays = {};


    if (data) {
        if (data.length > 0) {
            for (let i = 0; i < 30; i++) {
                const day = moment(now).add(-i, 'day');
                const dayKey = day.format(chartDateKeyFormat);

                dataByDays[dayKey] = {
                    interValue: 0,
                    interCost: 0,
                    indexValue: 0,
                    indexCost: 0,
                    costValue: 0,
                    cost: 0,
                    date: day.format(chartDateFormat),
                    ts: +day,
                };
            }
        }
        for (let i = 0; i < data.length; i++) {
            const item = data[i];
            if (item.showCost === false) {
                showMoney = false;
                break;
            }
        }

        for (let i = 0; i < data.length; i++) {
            const item = data[i];
            const timeTs = +item.timeTs;
            const day = moment(timeTs).format(chartDateKeyFormat);
            hasData = true;

            dataByDays[day] = {
                ...dataByDays[day],
                ...item
            };
        }
    }

    chartData = Object.values(dataByDays);
    chartData = _.sortBy(chartData, 'ts');

    return {
        hasData,
        chartData,
        showMoney
    };
}

export function convertCost(cost, showCost) {
    if (showCost) {
        return cost ? cost / 100 : 0;
    }
    return cost || 0;
}